import initialState from "../initialState";
import {
  CRAWLER_SOURCES_ARE_LOADING,
  CRAWLER_SOURCES_LOADED_WITH_ERROR,
  CRAWLER_SOURCES_SUCCESS_MESSAGE,
  CRAWLER_SOURCES_ARE_LOADED,
  PREVIEWED_CRAWLER_SOURCE_SUCCESSFULLY,
} from "../actions/actionTypes";

export default function sourcesReducer(
  state = initialState.sourceReducerState,
  action
) {
  switch (action.type) {
    case CRAWLER_SOURCES_ARE_LOADING: {
      return {
        ...state,
        sourcesAreLoading: action.sourcesAreLoading,
        sourcesAreLoadedWithError: false,
      };
    }

    case CRAWLER_SOURCES_LOADED_WITH_ERROR: {
      return {
        ...state,
        sourcesAreLoadedWithErrorMessage:
          action.sourcesAreLoadedWithErrorMessage,
        sourcesAreLoading: false,
        sourcesAreLoadedWithError: true,
      };
    }

    case CRAWLER_SOURCES_SUCCESS_MESSAGE: {
      return {
        ...state,
        sourcesSuccessMessage: action.sourcesSuccessMessage,
      };
    }

    case CRAWLER_SOURCES_ARE_LOADED: {
      return {
        ...state,
        sources: action.sources,
        sourcesAreLoading: false,
        sourcesAreLoadedWithError: false,
      };
    }

    case PREVIEWED_CRAWLER_SOURCE_SUCCESSFULLY: {
      return {
        ...state,
        previewedCrawlerSource: action.previewedCrawlerSource,
      };
    }

    default: {
      return state;
    }
  }
}
